<script>
export default {
  props: {
    secondsRemaining: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      countdownTimer: null,
      expired: false,
      countdownStr: '--:--',
      seconds: 0,
    };
  },
  watch: {
    secondsRemaining: function() {
      this.seconds = this.secondsRemaining;
      if (this.countdownTimer) clearInterval(this.countdownTimer);
      this.countdownTimer = setInterval(this.updateSecondsRemaining, 1000);
    },
  },
  // mounted() {
  //   this.countdownTimer = setInterval(this.updateSecondsRemaining, 1000);
  // },
  methods: {
    updateSecondsRemaining() {
      this.seconds--;

      if (this.seconds <= 0) {
        clearInterval(this.countdownTimer);
        this.expired = true;
        this.$emit('on-end', '00:00');
        return;
      }

      // 格式化时间字符串
      const minutes = Math.floor(this.seconds / 60);
      const seconds = this.seconds % 60;
      this.countdownStr = minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');
    },
  },
  destroyed() {
    clearInterval(this.countdownTimer);
  },
};
</script>

<template>
  <span>
    {{ countdownStr }}
  </span>
</template>

<style scoped lang="less"></style>